/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const subscriptionEventSchema = z.enum(['changed'])

export type SubscriptionEventSchema = z.infer<typeof subscriptionEventSchema>
